import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 43 43",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.5 43C9.626 43 0 33.374 0 21.5S9.626 0 21.5 0 43 9.626 43 21.5c-.013 11.868-9.632 21.487-21.5 21.5ZM4.3 21.87a17.2 17.2 0 1 0 0-.37v.37Zm12.9 9.305v-19.35L30.1 21.5l-12.9 9.675Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }